import { NetworkName } from '@features/lockup/types';
import { shortString } from '@features/lockup/utils/generate-short-string';
import { makeAddressUrl } from '@features/web3/utils/make-address-url';
import { toChainId } from '@features/web3/utils/to-chain-id';
import { AppState } from '@state';
import { CopyLink } from '@uikit/copy-link';
import { EtherscanLink } from '@uikit/etherscan-link';
import { useSelector } from 'react-redux';
import styles from './styles.module.scss';

interface Props {
  nameContract: string;
  address: string | undefined | any;
  description: string;
}

const SmartItem = ({ nameContract, address, description }: Props) => {
  const networkName = useSelector<AppState, NetworkName>(state => state.lockup.networkName);

  return (
    <div className={styles.smartItem}>
      <span>{nameContract}</span>
      <p>{description}</p>
      <h3>{shortString(address, 14, -14)}</h3>
      <div className={styles.actions}>
        <CopyLink value={address} />
        <EtherscanLink value={makeAddressUrl(toChainId(networkName), address)} />
      </div>
    </div>
  );
};

export default SmartItem;
